import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPublicConfig } from '../services/api';

const AppConfigContext = createContext();

export const AppConfigProvider = ({ children }) => {
  const [appName, setAppName] = useState('PassAm');

  useEffect(() => {
    getPublicConfig()
      .then((data) => {
        if (data && data.appName) setAppName(data.appName);
      })
      .catch(() => {});
  }, []);

  const value = { appName };
  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => {
  const ctx = useContext(AppConfigContext);
  if (!ctx) return { appName: 'PassAm' };
  return ctx;
};
